import { gql } from '@apollo/client';

export const GET_TMS_EXCEPTIONS_BY_CURRENT_ACCOUNT = gql`
  query GetTmsExceptionsByCurrentAccount {
    getTmsExceptionsByCurrentAccount {
      id
      taskId
      taskNumber
      driverId
      exceptionReasonType
      location
      remark
      exceptionPhotosJson
      exceptionPhotosUrlsJson
      createdAt
      updatedAt
    }
  }
`;

export interface TmsExceptionType {
  id: string;
  taskId: number;
  taskNumber?: string | null;
  driverId: number;
  exceptionReasonType: number;
  location: string;
  remark?: string | null;
  exceptionPhotosJson: string[];
  exceptionPhotosUrlsJson: string[];
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface GetTmsExceptionsByCurrentAccountResponse {
  getTmsExceptionsByCurrentAccount: TmsExceptionType[];
}

